import { createContext } from "react";
import { Store } from "redux";
import { ITmdState } from "src/reducers";

const ReduxContext = createContext<Store<ITmdState>>(undefined)

export default ReduxContext;